// src/firebase/functions.ts
import { app } from "./app";
import { getFunctions } from "firebase/functions";

// Ajusta la región si usas otra
export const functions = getFunctions(app, "us-central1");
